// Auto-generated by forge/extract-bytecodes.ts — DO NOT EDIT
// Source: forge/out/V4Quoter.sol/V4Quoter.json

export const V4_QUOTER_ABI = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_poolManager",
        type: "address",
        internalType: "contract IPoolManager",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "_quoteExactInput",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactParams",
        components: [
          {
            name: "exactCurrency",
            type: "address",
            internalType: "Currency",
          },
          {
            name: "path",
            type: "tuple[]",
            internalType: "struct PathKey[]",
            components: [
              {
                name: "intermediateCurrency",
                type: "address",
                internalType: "Currency",
              },
              {
                name: "fee",
                type: "uint24",
                internalType: "uint24",
              },
              {
                name: "tickSpacing",
                type: "int24",
                internalType: "int24",
              },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks",
              },
              {
                name: "hookData",
                type: "bytes",
                internalType: "bytes",
              },
            ],
          },
          {
            name: "exactAmount",
            type: "uint128",
            internalType: "uint128",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "_quoteExactInputSingle",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactSingleParams",
        components: [
          {
            name: "poolKey",
            type: "tuple",
            internalType: "struct PoolKey",
            components: [
              {
                name: "currency0",
                type: "address",
                internalType: "Currency",
              },
              {
                name: "currency1",
                type: "address",
                internalType: "Currency",
              },
              {
                name: "fee",
                type: "uint24",
                internalType: "uint24",
              },
              {
                name: "tickSpacing",
                type: "int24",
                internalType: "int24",
              },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks",
              },
            ],
          },
          {
            name: "zeroForOne",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "exactAmount",
            type: "uint128",
            internalType: "uint128",
          },
          {
            name: "hookData",
            type: "bytes",
            internalType: "bytes",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "_quoteExactOutput",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactParams",
        components: [
          {
            name: "exactCurrency",
            type: "address",
            internalType: "Currency",
          },
          {
            name: "path",
            type: "tuple[]",
            internalType: "struct PathKey[]",
            components: [
              {
                name: "intermediateCurrency",
                type: "address",
                internalType: "Currency",
              },
              {
                name: "fee",
                type: "uint24",
                internalType: "uint24",
              },
              {
                name: "tickSpacing",
                type: "int24",
                internalType: "int24",
              },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks",
              },
              {
                name: "hookData",
                type: "bytes",
                internalType: "bytes",
              },
            ],
          },
          {
            name: "exactAmount",
            type: "uint128",
            internalType: "uint128",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "_quoteExactOutputSingle",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactSingleParams",
        components: [
          {
            name: "poolKey",
            type: "tuple",
            internalType: "struct PoolKey",
            components: [
              {
                name: "currency0",
                type: "address",
                internalType: "Currency",
              },
              {
                name: "currency1",
                type: "address",
                internalType: "Currency",
              },
              {
                name: "fee",
                type: "uint24",
                internalType: "uint24",
              },
              {
                name: "tickSpacing",
                type: "int24",
                internalType: "int24",
              },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks",
              },
            ],
          },
          {
            name: "zeroForOne",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "exactAmount",
            type: "uint128",
            internalType: "uint128",
          },
          {
            name: "hookData",
            type: "bytes",
            internalType: "bytes",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "msgSender",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "poolManager",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IPoolManager",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "quoteExactInput",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactParams",
        components: [
          {
            name: "exactCurrency",
            type: "address",
            internalType: "Currency",
          },
          {
            name: "path",
            type: "tuple[]",
            internalType: "struct PathKey[]",
            components: [
              {
                name: "intermediateCurrency",
                type: "address",
                internalType: "Currency",
              },
              {
                name: "fee",
                type: "uint24",
                internalType: "uint24",
              },
              {
                name: "tickSpacing",
                type: "int24",
                internalType: "int24",
              },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks",
              },
              {
                name: "hookData",
                type: "bytes",
                internalType: "bytes",
              },
            ],
          },
          {
            name: "exactAmount",
            type: "uint128",
            internalType: "uint128",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "amountOut",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "gasEstimate",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "quoteExactInputSingle",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactSingleParams",
        components: [
          {
            name: "poolKey",
            type: "tuple",
            internalType: "struct PoolKey",
            components: [
              {
                name: "currency0",
                type: "address",
                internalType: "Currency",
              },
              {
                name: "currency1",
                type: "address",
                internalType: "Currency",
              },
              {
                name: "fee",
                type: "uint24",
                internalType: "uint24",
              },
              {
                name: "tickSpacing",
                type: "int24",
                internalType: "int24",
              },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks",
              },
            ],
          },
          {
            name: "zeroForOne",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "exactAmount",
            type: "uint128",
            internalType: "uint128",
          },
          {
            name: "hookData",
            type: "bytes",
            internalType: "bytes",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "amountOut",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "gasEstimate",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "quoteExactOutput",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactParams",
        components: [
          {
            name: "exactCurrency",
            type: "address",
            internalType: "Currency",
          },
          {
            name: "path",
            type: "tuple[]",
            internalType: "struct PathKey[]",
            components: [
              {
                name: "intermediateCurrency",
                type: "address",
                internalType: "Currency",
              },
              {
                name: "fee",
                type: "uint24",
                internalType: "uint24",
              },
              {
                name: "tickSpacing",
                type: "int24",
                internalType: "int24",
              },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks",
              },
              {
                name: "hookData",
                type: "bytes",
                internalType: "bytes",
              },
            ],
          },
          {
            name: "exactAmount",
            type: "uint128",
            internalType: "uint128",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "amountIn",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "gasEstimate",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "quoteExactOutputSingle",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactSingleParams",
        components: [
          {
            name: "poolKey",
            type: "tuple",
            internalType: "struct PoolKey",
            components: [
              {
                name: "currency0",
                type: "address",
                internalType: "Currency",
              },
              {
                name: "currency1",
                type: "address",
                internalType: "Currency",
              },
              {
                name: "fee",
                type: "uint24",
                internalType: "uint24",
              },
              {
                name: "tickSpacing",
                type: "int24",
                internalType: "int24",
              },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks",
              },
            ],
          },
          {
            name: "zeroForOne",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "exactAmount",
            type: "uint128",
            internalType: "uint128",
          },
          {
            name: "hookData",
            type: "bytes",
            internalType: "bytes",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "amountIn",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "gasEstimate",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "unlockCallback",
    inputs: [
      {
        name: "data",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "error",
    name: "NotEnoughLiquidity",
    inputs: [
      {
        name: "poolId",
        type: "bytes32",
        internalType: "PoolId",
      },
    ],
  },
  {
    type: "error",
    name: "NotPoolManager",
    inputs: [],
  },
  {
    type: "error",
    name: "NotSelf",
    inputs: [],
  },
  {
    type: "error",
    name: "QuoteSwap",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "UnexpectedCallSuccess",
    inputs: [],
  },
  {
    type: "error",
    name: "UnexpectedRevertBytes",
    inputs: [
      {
        name: "revertData",
        type: "bytes",
        internalType: "bytes",
      },
    ],
  },
] as const;

export const V4_QUOTER_BYTECODE =
  "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" as const;
